import React, { useContext, useEffect } from 'react';
import AppContext from '../../context/app/AppContext';
import Features from './components/Features/Features';
import FutureDefi from './components/FutureDefi/FutureDefi';
import Partners from './components/Partners/Partners';
import TechStack from './components/TechStack/TechStack';
import WhatCrytical from './components/WhatCrytical/WhatCrytical';
import styles from './Home.module.scss';

const Home = () => {
  const appContext = useContext(AppContext)

  const { setNavbarValue } = appContext;

  useEffect(()=>{
    setNavbarValue(true)
  },[])
  
  return (
  <div className={styles.Home}>
    <FutureDefi/>
    <WhatCrytical/>
    <Features/>
    <TechStack/>
    {/* <Team/> */}
    <Partners/>
  </div>
)};

Home.propTypes = {};

Home.defaultProps = {};

export default Home;
